<div
  class="bg-linear-to-t flex min-h-dvh w-full flex-col from-white to-brand-primary-lightest"
  role="status"
  aria-live="polite"
>
  <header class="flex shrink-0 justify-center px-4 pb-3 pt-8">
    <div class="flex max-w-xs items-center justify-center">
      <img
        src="assets/images/logo-icon-LIV.webp"
        alt="LIV"
        class="h-12 w-auto max-w-full select-none object-contain object-center"
      />
    </div>
  </header>

  <!-- Ocupa o espaço entre logo e rodapé e centra o bloco (vertical + horizontal). -->
  <div
    class="flex min-h-0 flex-1 flex-col items-center justify-center px-4 pb-8 pt-4 sm:px-6"
  >
    <div
      class="mx-auto flex w-full max-w-md flex-col items-center gap-8 text-neutral-low-dark"
    >
      <div class="flex shrink-0 flex-col items-center gap-3">
        <liv-spin-loader class="shrink-0" size="lg" variant="primary" />

        <div class="select-none">
          <h6 class="text-center font-roboto text-xl font-medium text-current">
            {{ titleKey() | translate }}
          </h6>
          <p class="text-center font-roboto text-base font-normal text-current">
            {{ messageKey() | translate }}
          </p>
        </div>
      </div>

      <span class="sr-only">{{ 'loading.pleaseWait' | translate }}</span>
    </div>
  </div>

  <footer class="flex shrink-0 justify-center px-4 pb-6 pt-2">
    <span class="select-none text-xs text-neutral-low-light">
      {{ 'loading.footerCopyright' | translate: { year: currentYear } }}
    </span>
  </footer>
</div>
